<template>
  <div>
    <v-row justify="center">
      <v-col align-self="center" cols="2" sm="2" md="2"  >
        <p style="margin:0px;">{{ currentPage }} / {{ maxPage }}</p>
      </v-col>
      <v-col cols="1" sm="1" md="1" >
        <v-btn block color="white" class="black--text" v-on:click="prev" >&lt;</v-btn>
      </v-col>
      <v-col cols="1" sm="1" md="1" >
        <v-btn block color="white" class="black--text" v-on:click="next" >&gt;</v-btn>
      </v-col>
    </v-row>
    <template v-if="!isEnableMeet">
      <v-card
        color="grey lighten-3"
        class="preview-card"
        :style="scaleStyles"
      >
        <div class="pdf-document" v-bind:style="fieldStyle">
          <div>
            <div style="margin: 0px 50px;">
              <v-overlay :absolute="true" :value="isLoading">
                <v-progress-circular
                  indeterminate
                  size="64"
                ></v-progress-circular>
              </v-overlay>
              <pdf-preview-page-component
                v-for="page in pages"
                v-bind="{page, scale}"
                :key="page.pageNumber"
                style="position:absolute"
                :setFieldStyle="setFieldStyle"
              />
              <template v-if="Object.entries(currentInputs).length > 0 && fieldStyle != null">
                <template v-for="(pageData, i) in Object.entries(currentInputs)" >
                  <view-input-item-component
                    v-for="(inputData, index) in Object.entries(pageData[1])"
                    :key="`${i}-${index}-${currentPage}`"
                    :type="inputData[1].type"
                    :destinations="destinations"
                    :x="inputData[1].x"
                    :y="inputData[1].y"
                    :value="inputData[1].value"
                    :label="inputData[1].label"
                    :defaultValue="inputData[1].defaultValue"
                    :destinationId="inputData[1].destinationId"
                    :required="inputData[1].required"
                    :objectId="inputData[0]"
                    :page="pageData[0]"
                    :pdfId="pdfId"
                    :color="inputData[1].color"
                    :colorsIdMap="colorsIdMap"
                    :bgColorsIdMap="bgColorsIdMap"
                    :createUserId="createUserId"
                    :selectItems="inputData[1].selectItems"
                    v-show="isShowElement(pageData[0]) && !inputData[1].deleted"
                  >
                  </view-input-item-component>
                </template>
              </template>
            </div>
          </div>
        </div>
      </v-card>
    </template>
    <template v-else>
      <v-card
        class="preview-card-meet scaleStylesMeet"
        v-bind:style="scaleStyles"
      >
        <v-row justify="center">
          <v-col cols="5">
            <div id="meet"></div>
          </v-col>
          <v-col cols="7">
            <div class="pdf-document" v-bind:style="fieldStyle">
              <div>
                <div style="margin: 0px 0px;">
                  <v-overlay :absolute="true" :value="isLoading">
                    <v-progress-circular
                      indeterminate
                      size="64"
                    ></v-progress-circular>
                  </v-overlay>
                  <pdf-preview-page-component
                    v-for="page in pages"
                    v-bind="{page, scale}"
                    :key="page.pageNumber"
                    style="position:absolute"
                    :setFieldStyle="setFieldStyle"
                  />
                  <template v-if="Object.entries(currentInputs).length > 0 && fieldStyle != null">
                    <template v-for="(pageData, i) in Object.entries(currentInputs)">
                      <view-input-item-component
                        v-for="(inputData, index) in Object.entries(pageData[1])"
                        :key="`${i}-${index}-${currentPage}`"
                        :type="inputData[1].type"
                        :destinations="destinations"
                        :x="inputData[1].x"
                        :y="inputData[1].y"
                        :value="inputData[1].value"
                        :label="inputData[1].label"
                        :defaultValue="inputData[1].defaultValue"
                        :destinationId="inputData[1].destinationId"
                        :required="inputData[1].required"
                        :objectId="inputData[0]"
                        :page="pageData[0]"
                        :pdfId="pdfId"
                        :color="inputData[1].color"
                        :colorsIdMap="colorsIdMap"
                        :bgColorsIdMap="bgColorsIdMap"
                        :createUserId="createUserId"
                        :selectItems="inputData[1].selectItems"
                        v-show="isShowElement(pageData[0]) && !inputData[1].deleted"
                      >
                      </view-input-item-component>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </div>
</template>

<script>
// import range from 'lodash/range';
import * as pdfjsLib from 'pdfjs-dist';
import "pdfjs-dist/web/pdf_viewer.css";
export default {
  props: ['scale', 'pdfId', 'pdfData', 'destinations', 'colorsIdMap', 'bgColorsIdMap', 'createUserId', 'registeredInputs', 'scaleStyles'],

  data() {
    return {
      pdf: undefined,
      pages: [],
      maxPage: 1,
      currentPage: 1,
      isLoading: false,
      textMinWidth: "200px",
      textMinHeight: "60px",
      textMaxWidth: 200,
      textMaxHeight: 60,
      checkboxMaxWidth: 40,
      checkboxMaxHeight: 40,
      sealMaxWidth: 40,
      sealMaxHeight: 40,
      inputs: { // 契約書単位の入力項目を保持する
        /*
          1 : {
              1 : {
                  type: "text",
                  destinationId: 1,
                  label: "ラベル",
                  required: true,
                  x: "100px",
                  y: "200px",
                  value: "",
              }
          }
        */
      },
      currentInputs: {}, // 画面描画用の入力項目
      fieldStyle: null,
      times: 2,
      isEnableMeet: false,
    };
  },
  created() {
    pdfjsLib.GlobalWorkerOptions.workerSrc = "/documents/js/pdf.worker.js";
    this.fetchPDF();
    // 入力項目を配置
    // this.inputs = Object.assign({}, this.registeredInputs);
    this.currentInputs = Object.assign({}, this.registeredInputs);
    if (this.destinations[0]["destination_company_name"] == "株式会社バルテック") {
      this.isEnableMeet = true;
      this.loadJitsiScript(() => {
        if (!window.JitsiMeetExternalAPI) throw new Error('Jitsi Meet API not loaded');
        this.embedJitsiWidget();
      });
    }
  },

  methods: {
    setFieldStyle(width, height) {
      this.fieldStyle = { width: (width/this.times + 100) + 'px', height: (height/this.times + 40) + 'px', 'padding-top': '20px', 'margin-top': '20px' };
      this.$nextTick(() => {
          window.dispatchEvent(new Event('resize'))
      })
    },
    fetchPDF: async function () {
      this.setLoading(true);
      this.$emit('loading', true);

      let loadingTask = pdfjsLib.getDocument({
          data: window.atob(this.pdfData),
          cMapUrl: '/documents/cmaps/',
          cMapPacked: true,
      });

      let loadpdf = await loadingTask.promise;
      this.pdf = loadpdf;
      this.maxPage = loadpdf.numPages;
      this.setLoading(false);
      this.$emit('loading', false);
    },
    fetchNewPDF: async function () {
      this.firstPage();
      this.fetchPDF();
    },
    isFirst: function () {
      return this.currentPage <= 1;
    },
    isEnd: function () {
      return this.currentPage >= this.maxPage;
    },
    prev: function () {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
    },
    next: function () {
      if (this.currentPage < this.maxPage) {
        this.currentPage += 1;
      }
    },
    firstPage: function () {
      this.currentPage = 1;
    },
    changePage: function(pageNum) {
      this.currentPage = pageNum;
      this.$nextTick(function() {
        this.$emit('loading', false);
      });
    },
    setLoading: function (loading) {
        this.isLoading = loading;
    },
    isShowElement: function (page) {
      return this.currentPage === Number(page);
    },
    loadJitsiScript (cb) {
      const scriptEl = document.createElement('script');
      scriptEl.src = "https://m2.valtec.co.jp/external_api.js";
      scriptEl.async = 1;
      document.querySelector('head').appendChild(scriptEl);
      scriptEl.addEventListener('load', cb);
    },
    embedJitsiWidget () {
      // /var/www/src/resources/js/components/layout/SignLayoutComponent.vueと共通
      const rname = this.destinations[0]["agreement_id"];
      const domain = "m2.valtec.co.jp";
      const options = {
        roomName: rname,
        width: 420,
        height: 453,
        parentNode: document.querySelector("#meet"),
        lang: 'ja',
        configOverwrite: { disableDeepLinking: true},
        interfaceConfigOverwrite: { TOOLBAR_BUTTONS: ["microphone","camera","desktop","hangup","recording", 'participants-pane',"fullscreen"] }
      };
      //オブジェクト確認用 console.log(this.destinations);
      const api = new window.JitsiMeetExternalAPI(domain, options);
    },
  },
  watch: {
    pdf(pdf) {
      this.pages = [];
      Promise.all([pdf.getPage(this.currentPage)]).
        then(pages => (this.pages = pages));
    },
    currentPage(pageNum) {
      // ページ切り替えの際に埋め込み画像等が消える問題があったため、保持しているPDFデータを都度読み込み直す
      var my = this;
      this.pdf.getData().then(async function(arrayBuffer) {
        my.setLoading(true);
        my.$emit('loading', true);
        let loadingTask = pdfjsLib.getDocument({
            data: arrayBuffer,
            cMapUrl: '/documents/cmaps/',
            cMapPacked: true,
        });
        my.pdf = await loadingTask.promise;
        await my.pdf.getPage(pageNum);
        my.setLoading(false);
        my.$emit('loading', false);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .pdf-document{
      width: 100%;
      height: 100vh;
    }

    .circle{
      display: inline-block;
      width: 40px;
      height: 40px;
      text-align:center;
      line-height: 40px;
      border-radius: 50%;
      border: solid 3px blue;
    }

    .text-drag-form {
      border: none;
    }

    .preview-card {
      margin-left: 150px;
      margin-bottom: 100px;
    }
    .preview-card-meet {
      margin-left: 0px;
      margin-top:0px;
      padding:0;
      margin-bottom: 100px;
      width: 100%;
      background:none;
      border-radius:0;
      box-shadow:0 0 0 0;
    }
    .scaleStylesMeet{
      width: 100%;
    }
    #meet{margin:40px 0 0 30px;}
    .v-sheet.v-card:not(.v-sheet--outlined) {
      box-shadow: 0 0 0 0 rgba(0,0,0,.2), 0 0 0 0 rgba(0,0,0,.14), 0 0 0 0 rgba(0,0,0,.12);
    }
</style>
